// extracted by mini-css-extract-plugin
module.exports = {"main":"Location_main__1138o","container":"Location_container__2IK-h","info":"Location_info__2igcj","location":"Location_location__CWeBO"};